import trTR from "antd/locale/tr_TR";
import { ConfigProvider, theme } from "antd";

export const AntdConfigProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ConfigProvider
      componentSize={window.innerWidth < 768 ? "small" : "middle"}
      locale={trTR}
      theme={{
        algorithm: theme.compactAlgorithm,
        token: {
          //  zIndexPopupBase: 11000,
          colorPrimary: "#F89C2E",
        },
        components: {
          Layout: {
            siderBg: "#ffffff",
            headerPadding: 10,
          },
          Menu: {
            itemSelectedBg: "#00000022",
            itemSelectedColor: "#333",
            itemHoverBg: "#f5f5f5",
            itemHoverColor: "#333",
            iconSize: 16,
            collapsedIconSize: 18,
          },
          Segmented: {
            itemSelectedBg: "#F89C2E",
            itemSelectedColor: "#fff",
          },
          Table: {
            //   headerBg: "#DF0210",
            headerBg: "#00000022",
            //   headerColor: "#ffffff",
          },
          Modal: {
            titleFontSize: window.innerWidth < 768 ? 18 : 24,
            paddingContentVerticalLG: window.innerWidth < 768 ? 10 : 24,
            paddingContentHorizontalLG: window.innerWidth < 768 ? 10 : 24,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
